export default (animationStyle = 'fade') => ({
  animationStyle: animationStyle,
  observedItems: new Set(),

  init() {
    if (this.animationStyle === 'none') return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.observedItems.has(entry.target)) {
            this.observedItems.add(entry.target)
            this.animateItem(entry.target)
          }
        })
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
      }
    )

    const items = this.$el.querySelectorAll('.timeline-item')
    items.forEach((item, index) => {
      if (this.animationStyle === 'fade') {
        item.style.opacity = '0'
        item.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out'
      } else if (this.animationStyle === 'slide') {
        item.style.opacity = '0'
        item.style.transform = 'translateY(30px)'
        item.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out'
      }
      observer.observe(item)
    })

    this.$el._cleanup = () => {
      observer.disconnect()
    }
  },

  animateItem(item) {
    const index = parseInt(item.dataset.index)
    const delay = (index - 1) * 100

    setTimeout(() => {
      if (this.animationStyle === 'fade') {
        item.style.opacity = '1'
      } else if (this.animationStyle === 'slide') {
        item.style.opacity = '1'
        item.style.transform = 'translateY(0)'
      }
    }, delay)
  },

  destroy() {
    if (this.$el._cleanup) {
      this.$el._cleanup()
    }
  }
})
